module.exports = __webpack_public_path__ + "img/student-brief (8).9d1ab2f4.png";